export const TARGETS = {
  PROJECT_DETAIL: 'projectDetail'
};

export const DEFAULT_STATE = {
  projectDetail: null
};
